var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-actions"},[_c('button',{staticClass:"btn btn-sm btn-success fa fa-pencil",attrs:{"title":"Editar"},on:{"click":function($event){return _vm.editar(_vm.rowData, _vm.rowIndex)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }